import dynamicLocalization from "@/mixins/dynamic-localization";
import SegmentedContent from "@/components/content-block/text/segmented-content/index";

export default {
  components: { SegmentedContent },
  mixins: [dynamicLocalization],
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
